<template>
    <div class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('publicOrder.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="redirectToList"
                >
                    <i class="fas fa-th-list"></i> {{ $t("backToList") }}
                </button>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">
                        {{ $t("publicOrder.title") }}
                    </div>
                </div>
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="form-group col-6">
                            <label class="font-weight-bold">{{
                                $t("publicOrder.currentNumberPublicOrders")
                            }}</label>
                            <input
                                type="text"
                                class="form-control"
                                readonly
                                v-model="publicOrder.publicOrdersCurrentNumber"
                            />
                        </div>
                        <div class="form-group col-6">
                            <label class="font-weight-bold">{{
                                $t("publicOrder.currentNumberNIP")
                            }}</label>
                            <input
                                type="text"
                                class="form-control"
                                readonly
                                v-model="publicOrder.currentNumberNIP"
                            />
                        </div>
                    </div>
                    <div class="form-group col-12 p-0 mb-3">
                        <label class="font-weight-bold">{{
                            $t("publicOrder.itemName")
                        }}</label>
                        <input
                            type="text"
                            class="form-control"
                            readonly
                            v-model="publicOrder.itemName"
                        />
                    </div>
                    <div class="row mb-3">
                        <div class="form-group col-4">
                            <label class="font-weight-bold">{{
                                $t("publicOrder.status")
                            }}</label>
                            <input
                                type="text"
                                class="form-control"
                                readonly
                                v-model="publicOrder.status"
                            />
                        </div>
                        <div class="form-group col-4">
                            <label class="font-weight-bold">{{
                                $t("publicOrder.publishDate")
                            }}</label>
                            <date-picker
                                v-model="publicOrder.publishDate"
                            ></date-picker>
                        </div>
                        <div class="form-group col-4">
                            <label class="font-weight-bold">{{
                                $t("publicOrder.termDate")
                            }}</label>
                            <date-picker
                                v-model="publicOrder.termDate"
                            ></date-picker>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="form-group col-6">
                            <label class="font-weight-bold">{{
                                $t("publicOrder.orderType")
                            }}</label>
                            <input
                                type="text"
                                class="form-control"
                                readonly
                                v-model="publicOrder.orderType"
                            />
                        </div>
                        <div class="form-group col-6">
                            <label class="font-weight-bold">{{
                                $t("publicOrder.typeOfOrderType")
                            }}</label>
                            <input
                                type="text"
                                class="form-control"
                                readonly
                                v-model="publicOrder.typeOfOrderType"
                            />
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="form-group col-6">
                            <label
                                :for="'objectType' + _uid"
                                class="font-weight-bold required"
                            >
                                {{ $t("publicOrder.objectType") }}
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                readonly
                                v-model="publicOrder.objectType"
                            />
                        </div>
                        <div class="form-group col-4">
                            <label
                                :for="'referenceValue' + _uid"
                                class="font-weight-bold required"
                            >
                                {{ $t("publicOrder.referenceValue") }}
                            </label>
                            <input
                                type="text"
                                class="form-control mt-1"
                                readonly
                                v-model="publicOrder.referenceValue"
                            />
                        </div>
                        <div class="form-group col-2">
                            <label
                                :for="'referenceValueCurrency' + _uid"
                                class="font-weight-bold required"
                            >
                                {{ $t("publicOrder.referenceValueCurrency") }}
                            </label>
                            <input
                                type="text"
                                class="form-control mt-1"
                                readonly
                                v-model="publicOrder.referenceValueCurrency"
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="referenceOrder" class="font-weight-bold">
                            {{ $t("publicOrder.referenceOrder") }}
                        </label>
                        <input
                            type="text"
                            class="form-control mt-1"
                            readonly
                            v-model="publicOrder.referenceOrder"
                        />
                    </div>
                    <div class="form-group">
                        <label for="activity" class="font-weight-bold">
                            {{ $t("publicOrder.activity") }}
                        </label>
                        <input
                            type="text"
                            class="form-control mt-1"
                            readonly
                            v-model="publicOrder.activity"
                        />
                    </div>
                    <div class="form-group col-12 p-0 mb-3">
                        <label
                            :for="'description' + _uid"
                            class="font-weight-bold required"
                        >
                            {{ $t("publicOrder.description") }}
                        </label>
                        <textarea
                            class="form-control"
                            readonly
                            v-model="publicOrder.description"
                        ></textarea>
                    </div>
                    <div class="form-group col-12 p-0">
                        <other-fields
                            :otherFields="publicOrder.otherFields"
                        ></other-fields>
                    </div>
                </div>
            </div>
            <div
                class="card mt-3"
                v-if="publicOrder.publicOrderToContactModels > 0"
            >
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">
                        {{ $t("publicOrder.contactPerson") }}
                    </div>
                </div>
                <div class="card-body">
                    <div
                        class="mt-2 p-2"
                        v-for="(contact,index) in publicOrder.publicOrderToContactModels"
                        :key="index"
                    >
                        <div class="k-display-flex align-items-center">
                            <div class="col-12">
                                <div class="row">
                                    <div class="form-group col-6">
                                        <label
                                            :for="'referenceValue' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("person.firstName") }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control mt-1"
                                            v-model="contact.name"
                                            readonly
                                        />
                                    </div>
                                    <div class="form-group col-6">
                                        <label
                                            :for="'referenceValue' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("email") }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control mt-1"
                                            v-model="contact.email"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-6">
                                        <label
                                            :for="'referenceValue' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("person.phone") }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control mt-1"
                                            v-model="contact.phoneWork"
                                            readonly
                                        />
                                    </div>
                                    <div class="form-group col-6">
                                        <label
                                            :for="'referenceValue' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("person.mobilePhone") }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control mt-1"
                                            v-model="contact.phonePrivate"
                                            readonly
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">
                        {{ $t("publicOrder.documents") }}
                    </div>
                </div>
                <div class="card-body">
                    <div class="form-group col-12 p-0">
                        <div>
                            <div class="form-group col-12">
                                <label
                                    :for="'description' + _uid"
                                    class="font-weight-bold"
                                >
                                    {{ $t("publicOrder.fileNumber") }}
                                </label>
                                <input
                                    type="text"
                                    class="form-control mt-1"
                                    v-model="publicOrder.fileNumber"
                                    readonly
                                />
                            </div>
                        </div>
                        <div v-if="manualDocsType.length > 0">
                            <div class="card-header">
                                <label
                                    :for="'manualDocsType' + _uid"
                                    class="font-weight-bold"
                                    >{{
                                        $t("publicOrder.manualDocsType")
                                    }}</label
                                >
                                <button
                                    class="float-right"
                                    type="button"
                                    @click="showManualDocs = !showManualDocs"
                                >
                                    <i
                                        :class="
                                            showManualDocs
                                                ? 'fas fa-minus'
                                                : 'fas fa-plus'
                                        "
                                    ></i>
                                </button>
                            </div>
                            <div
                                v-for="(document, index) in manualDocsType"
                                :key="index"
                                class="mt-2 border border-light-2 p-2"
                                v-show="showManualDocs"
                            >
                                <div
                                    class="col-12 align-items-center k-display-flex"
                                >
                                    <div class="form-group col-6">
                                        <label
                                            :for="'description' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("publicOrder.documentType") }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control mt-1"
                                            v-model="document.type"
                                            readonly
                                        />
                                    </div>
                                    <fileDownload
                                        :file="document"
                                        :showDescription="false"
                                    ></fileDownload>
                                </div>
                                <div class="col-12">
                                    <div class="form-group col-6">
                                        <label
                                            :for="'description' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("publicOrder.documentDate") }}
                                        </label>
                                        <datePicker
                                            v-model="document.updateTimeUtc"
                                        ></datePicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="infoDocsType.length > 0">
                            <div class="card-header">
                                <label
                                    :for="'infoDocsType' + _uid"
                                    class="font-weight-bold"
                                    >{{ $t("publicOrder.infoDocsType") }}</label
                                >
                                <button
                                    type="button"
                                    class="float-right"
                                    @click="showInfoDocs = !showInfoDocs"
                                >
                                    <i
                                        :class="
                                            showInfoDocs
                                                ? 'fas fa-minus'
                                                : 'fas fa-plus'
                                        "
                                    ></i>
                                </button>
                            </div>
                            <div
                                v-for="(document, index) in infoDocsType"
                                :key="index"
                                class="mt-2 border border-light-2 p-2"
                                v-show="showInfoDocs"
                            >
                                <div
                                    class="col-12 align-items-center k-display-flex"
                                >
                                    <div class="form-group col-6">
                                        <label
                                            :for="'description' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("publicOrder.documentType") }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control mt-1"
                                            v-model="document.type"
                                            readonly
                                        />
                                    </div>
                                    <fileDownload
                                        :file="document"
                                        :showDescription="false"
                                    ></fileDownload>
                                </div>
                                <div class="col-12">
                                    <div class="form-group col-6">
                                        <label
                                            :for="'description' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("publicOrder.documentDate") }}
                                        </label>
                                        <datePicker
                                            v-model="document.updateTimeUtc"
                                        ></datePicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="contractDocsType.length > 0">
                            <div class="card-header">
                                <label
                                    :for="'contractDocsType' + _uid"
                                    class="font-weight-bold"
                                    >{{
                                        $t("publicOrder.contractDocsType")
                                    }}</label
                                >
                                <button
                                    type="button"
                                    class="float-right"
                                    @click="
                                        showContractDocs = !showContractDocs
                                    "
                                >
                                    <i
                                        :class="
                                            showContractDocs
                                                ? 'fas fa-minus'
                                                : 'fas fa-plus'
                                        "
                                    ></i>
                                </button>
                            </div>
                            <div
                                v-for="(document, index) in contractDocsType"
                                :key="index"
                                class="mt-2 border border-light-2 p-2"
                                v-show="showContractDocs"
                            >
                                <div
                                    class="col-12 align-items-center k-display-flex"
                                >
                                    <div class="form-group col-6">
                                        <label
                                            :for="'description' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("publicOrder.documentType") }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control mt-1"
                                            v-model="document.type"
                                            readonly
                                        />
                                    </div>
                                    <fileDownload
                                        :file="document"
                                        :showDescription="false"
                                    ></fileDownload>
                                </div>
                                <div class="col-12">
                                    <div class="form-group col-6">
                                        <label
                                            :for="'description' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("publicOrder.documentDate") }}
                                        </label>
                                        <datePicker
                                            v-model="document.updateTimeUtc"
                                        ></datePicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="statementDocsType.length > 0">
                            <div class="card-header">
                                <label
                                    :for="'statementDocsType' + _uid"
                                    class="font-weight-bold"
                                    >{{
                                        $t("publicOrder.contractDocsType")
                                    }}</label
                                >
                                <button
                                    type="button"
                                    class="float-right"
                                    @click="
                                        showStatementDocs = !showStatementDocs
                                    "
                                >
                                    <i
                                        :class="
                                            showStatementDocs
                                                ? 'fa fa-minus'
                                                : 'fa fa-plus'
                                        "
                                    ></i>
                                </button>
                            </div>
                            <div
                                v-for="(document, index) in statementDocsType"
                                :key="index"
                                class="mt-2 border border-light-2 p-2"
                                v-show="showStatementDocs"
                            >
                                <div
                                    class="col-12 align-items-center k-display-flex"
                                >
                                    <div class="form-group col-6">
                                        <label
                                            :for="'description' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("publicOrder.documentType") }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control mt-1"
                                            v-model="document.type"
                                            readonly
                                        />
                                    </div>
                                    <fileDownload
                                        :file="document"
                                        :showDescription="false"
                                    ></fileDownload>
                                </div>
                                <div class="col-12">
                                    <div class="form-group col-6">
                                        <label
                                            :for="'description' + _uid"
                                            class="font-weight-bold"
                                        >
                                            {{ $t("publicOrder.documentDate") }}
                                        </label>
                                        <datePicker
                                            v-model="document.updateTimeUtc"
                                        ></datePicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="card mt-3"
                v-if="publicOrder.statusChanges.length > 0"
            >
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">
                        {{ $t("publicOrder.statusHistory") }}
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>{{ $t("publicOrder.statusFrom") }}</th>
                                    <th>{{ $t("publicOrder.statusTo") }}</th>
                                    <th>
                                        {{ $t("publicOrder.statusUpdateDate") }}
                                    </th>
                                    <th>
                                        {{ $t("publicOrder.statusUpdatedBy") }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(statusChange,index) in publicOrder.statusChanges"
                                    :key="index"
                                >
                                    <td class="minWidth-200">
                                        {{ statusChange.previousStatus }}
                                    </td>
                                    <td class="minWidth-200">
                                        {{ statusChange.currentStatus }}
                                    </td>
                                    <td class="minWidth-200">
                                        <date-picker
                                            v-model="statusChange.updateTimeUtc"
                                            format="dd.MM.yyyy HH:mm"
                                        ></date-picker>
                                    </td>
                                    <td class="minWidth-200">
                                        {{ statusChange.user }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mt-3" v-if="publicOrder">
                <AuxiliaryRegisterDetails :entryId="publicOrder.auxRegisterEntityId"></AuxiliaryRegisterDetails>
            </div>
        </div>

        <div v-if="id">
            <HistoryRecordsGrid
                :id="id"
                :url="'api/history/publicOrder'"
                :columns="publicOrderHistoryGridColumns"
                :schemaModelFields="publicOrderHistoryGridSchemaModelFields"
                :componentName="'PublicOrderHistory'"
            >
            </HistoryRecordsGrid>
        </div>
    </div>
</template>

<script>
    import OtherFields from "../../../components/otherFields/OtherFieldsDetails.vue";
    import FileDownload from "../../../components/common/FileDownload.vue";
    import DatePicker from "../../../components/datepicker/DatePickerDetails.vue";
    import { PublicOrderDetails, CompanyDetails } from "../../../models/models";
    import PageTitle from "../../../components/common/PageTitle";
    import store from "../../../store/store";
    import HistoryRecordsGrid from "../../../components/history/HistoryRecordsGrid";
    import {
        publicOrderHistoryGridColumns,
        publicOrderHistoryGridSchemaModelFields,
    } from "../../../settings/historyGridsSettings";
    import AuxiliaryRegisterDetails from '../../../components/dynamic/AuxiliaryRegisterDetails'


export default {
    components: {
        DatePicker,
        OtherFields,
        FileDownload,
        PageTitle,
        HistoryRecordsGrid,
        AuxiliaryRegisterDetails
    },
    props: {
        id: {
            type: Number,
            required: true
        },
        returnUrl: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            publicOrder: new PublicOrderDetails(),
            company: new CompanyDetails(),
            loading: false,
            manualDocsType: [],
            infoDocsType: [],
            contractDocsType: [],
            statementDocsType: [],
            showManualDocs: false,
            showInfoDocs: false,
            showContractDocs: false,
            showStatementDocs: false,
            publicOrderHistoryGridColumns: publicOrderHistoryGridColumns,
            publicOrderHistoryGridSchemaModelFields: publicOrderHistoryGridSchemaModelFields,
        };
    },
    methods: {
        redirectToList() {
            if (this.token) {
                this.$router.push(this.returnUrl || '/registers/publicOrders');
            } else {
                this.$router.push(this.returnUrl || '/registers/publicOrders/publicList');
            }
        },
        loadData() {
            this.loading = true;
            this.$http
                .get(`/api/publicOrders/GetDetails/${this.id}`)
                .then((result) => {
                    this.publicOrder = new PublicOrderDetails(result.data);
                    this.separateDocuments();
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
        },
        separateDocuments() {
            this.publicOrder.documents.forEach((doc) => {
                if (doc.type === "Становище на АОП") {
                    this.statementDocsType.push(doc);
                } else if (
                    doc.type === "Договор, приложение, доп споразумение"
                ) {
                    this.contractDocsType.push(doc);
                } else if (
                    doc.type === "Указание" ||
                    doc.type === "Документация" ||
                    doc.type === "Образец"
                ) {
                    this.manualDocsType.push(doc);
                } else {
                    this.infoDocsType.push(doc);
                }
            });
        },
    },
    mounted() {
        this.loadData();
    },
    computed: {
        token: function () {
            return store.getters.authToken;
        },
    },
};
</script>

<style scoped>
input[readonly] {
    background-color: whitesmoke;
}

textarea[readonly] {
    background-color: whitesmoke;
}

.row {
    margin-bottom: 5px;
}

.minWidth-200 {
    min-width: 300px;
}
</style>
